import { render } from "./league-details-modal.vue?vue&type=template&id=68550f26"
import script from "./league-details-modal.vue?vue&type=script&lang=js"
export * from "./league-details-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__